module.exports = __webpack_public_path__ + "img/payment-type-bank.140bd1c2.svg";